<template>
  <div>
    <h4>{{ $t('Guests') }}</h4>
    <guests-list :guests="guests" read-only />

    <template v-if="requestsText">
      <h4 class="mt-4 mb-3">{{ $t('Special requests') }}</h4>
      <b-row>
        <b-col cols="12" sm="6">
          {{ requestsText }}
        </b-col>
      </b-row>
    </template>

    <b-row class="mt-4">
      <b-col class="d-flex justify-content-end">
        <b-button v-b-modal.edit-checkin-modal variant="primary">
          {{ $t('Edit') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, VBModal,
} from 'bootstrap-vue'
import GuestsList from '@/views/foravila/bookings/booking/components/checkin/GuestsList.vue'

export default {
  name: 'GuestsCard',
  components: {
    BButton,
    BRow,
    BCol,
    GuestsList,
  },
  directives: {
    'b-modal': VBModal,
  },
  computed: {
    booking() {
      return this.$store.getters['booking/booking']
    },
    details() {
      return this.$store.getters['booking/details']
    },
    guests() {
      return this.$store.getters['booking/guests']
    },
    babyCotsText() {
      const babyCotTranslation = this.$t('Baby cot').toLowerCase()
      const babyCotsTranslation = this.$t('Baby cots').toLowerCase()
      if (this.details.babyCots !== 1) return `${this.details.babyCots} ${babyCotsTranslation}`
      return `1 ${babyCotTranslation}`
    },
    babyChairsText() {
      const babyChairTranslation = this.$t('Baby chair').toLowerCase()
      const babyChairsTranslation = this.$t('Baby chairs').toLowerCase()
      if (this.details.babyChairs !== 1) return `${this.details.babyChairs} ${babyChairsTranslation}`
      return `1 ${babyChairTranslation}`
    },
    requestsText() {
      const babyCots = this.details.babyCots
      const babyChairs = this.details.babyChairs

      const text = [];
      if (babyCots > 0) {
        text.push(this.babyCotsText);
      }
      if (babyChairs > 0) {
        text.push(this.babyChairsText);
      }
      if (text.length === 0) return null
      return text.join(', ')
    },
  },
}
</script>
